import { useEffect, useState } from "react";
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import { useAuth } from "../contexts/AuthContext";
import type { Invite } from "../types";

interface InviteWithId extends Invite {
  id: string;
}

export function useInvites() {
  const { user } = useAuth();
  const [invites, setInvites] = useState<InviteWithId[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.email) {
      setInvites([]);
      setLoading(false);
      return;
    }

    const q = query(
      collection(db, "invites"),
      where("toEmail", "==", user.email.toLowerCase()),
      where("status", "==", "pending")
    );

    const unsub = onSnapshot(
      q,
      (snapshot) => {
        setInvites(
          snapshot.docs.map((doc) => ({
            id: doc.id,
            ...(doc.data() as Invite),
          }))
        );
        setLoading(false);
      },
      () => {
        setLoading(false);
      }
    );

    return unsub;
  }, [user?.email]);

  return { invites, loading };
}
